import { useRef, memo } from 'react';
import { useShallow } from 'zustand/react/shallow';
import type { TSkill } from '@newo/api/gateway';
import useLibraryStore from '@/pages/Library/Library.store';
import CodeEditor from '@/modules/CodeEditor';

interface ScriptEditorProps {
    skill: TSkill;
}

const ScriptEditor = ({ skill }: ScriptEditorProps) => {
    const editorRef = useRef<{ setValue: (script: string) => void }>(null);
    const skillId = skill.id;
    const { setSkillScript, skillScripts } = useLibraryStore(
        useShallow((state) => ({
            setSkillScript: state.setSkillScript,
            skillScripts: state.skillScripts
        }))
    );

    const code = skillScripts[skillId] ?? skill.prompt_script;

    const handleEditorChange = (value?: string) => {
        setSkillScript(skill.id, value);
    };

    return (
        <CodeEditor
            language={skill.runner_type}
            path={skillId}
            ref={editorRef}
            value={code}
            onChange={handleEditorChange}
        />
    );
};

export default memo(ScriptEditor);
